module.exports = __webpack_public_path__ + "static/story-23a3254cca6ae296ab8e20263219a2c9.png";